import { ApolloClient } from '@apollo/client';
import { CustomStaticContext } from '@catalogo/core-pre-render/src/types';
import { NormalizedCacheObject } from '@apollo/client/cache';
import query from './x-tid.graphql';

// eslint-disable-next-line @typescript-eslint/ban-types
type Client = ApolloClient<NormalizedCacheObject | Object>;

export const getXtid = (client: Client): string => {
  const data = client.readQuery({
    query,
  });

  return data?.xTid;
};

export const setXtidHeader = (client: Client, context: CustomStaticContext): void => {
  const xTid = getXtid(client);

  context.headers['x-tid'] = xTid;
};

export const generateXtid = (client: Client): void => {
  const xTid = getXtid(client);

  if (xTid) {
    return;
  }

  client.writeQuery({
    query: query,
    data: { xTid: randomId() },
  });
};
const randomId = () => [new Date().getTime(), Math.random().toString()].join('.');
